export default __webpack_public_path__ + "static/media/eth.7433db9e.png";